import React, { useEffect, useState } from 'react'
import MyMap from './MyMap'
import './Map.css'
import './MapLoader.css'

import { 
  tbbIlceler, tbbYol, tbbMahalle, 
  tbbYapi, tbbKapi, parsel 
} from "../Layers/Basemaps/OSMLayer";

export default function MapComponent({ token }) {

    const [start, setStart] = useState(false);
    const [loading, setLoading] = useState(true);

    // 3 Saniye bekleme
    useEffect(() => {
        if (!token) return;

        const timer = setTimeout(() => {
           

            // TOKEN GELİNCE PARAMS GÜNCELLE
            tbbIlceler.getSource().updateParams({ key: token });
            tbbYol.getSource().updateParams({ key: token });
            tbbMahalle.getSource().updateParams({ key: token });
            tbbYapi.getSource().updateParams({ key: token });
            tbbKapi.getSource().updateParams({ key: token });
            setLoading(false);
            setStart(true);


        }, 1500);

        return () => clearTimeout(timer);

    }, [token]);

    // MAP BAŞLAT
    useEffect(() => {
        if (start) {
            MyMap.setTarget("map");
        }
    }, [start]);

    return(
        <div id='map'>
            {loading && (
                <div className="map-loader-overlay">
                    <div className="map-loader-box">
                        <div className="map-spinner"></div>
                        Harita Yükleniyor...
                    </div>
                </div>
            )}
            </div>
        
    ) 
}
